import { Component } from '@angular/core';
import { UssdApplicationFormComponent } from '../application-form/application-form.component';

/** /applications/new — the shared application wizard in create mode. */
@Component({
  selector: 'app-create-application',
  standalone: true,
  imports: [UssdApplicationFormComponent],
  templateUrl: './create-application.component.html',
  styleUrl: './create-application.component.css',
})
export class CreateApplicationComponent {}
